export default "__VITE_ASSET__b7cefb57__"